import React from "react";
import { Card, CardBody, Col, Container, Row, ListGroup, ListGroupItem } from "reactstrap";
import Header from "components/Headers/Header";

const HowYouSucceed = () => {
  const isSmallScreen = window.innerWidth < 768;

  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          {/* Header */}
          <div className="bg-gradient-primary p-4 text-white">
            <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
              ATHLETE GUIDE
            </span>
            <h2 className="text-white mb-0 mt-1 font-weight-700">
              How You Succeed on FHP
            </h2>
          </div>
          
          <CardBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            <div className="text-center mb-5 mt-2">
              <h3 className="h2 text-dark font-weight-700 mb-2">
                Student Athlete, Listen Up...
              </h3>
              <p className="text-muted" style={{ fontSize: "1.05rem" }}>
                Yes, a goal on FHP is selling! But that is only part of the larger goal.
              </p>
            </div>

            <Row className="justify-content-center">
              {/* Left Side: Philosophy Card */}
              <Col lg="6" className="mb-4">
                <Card className="border-0 shadow-sm rounded-4 h-100 bg-white">
                  <CardBody className="p-4 d-flex flex-column justify-content-between">
                    <div>
                      <h4 className="text-primary font-weight-700 mb-3 d-flex align-items-center">
                        <i className="fas fa-bullseye mr-2 text-primary"></i> The Larger Goal
                      </h4>
                      <p className="text-dark mb-4" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                        Our larger goal is to <strong>succeed by giving fans a great experience</strong> in dealing with FHP. 
                      </p>
                      
                      <div className="p-3 mb-4 rounded-3 border-left border-warning" style={{ borderLeft: "4px solid #fb6340", backgroundColor: "#fffbeb" }}>
                        <p className="text-warning-darker mb-0 font-weight-600" style={{ fontSize: "0.95rem", color: "#b25e00" }}>
                          Be thankful to fans, even when they do not buy right away.
                        </p>
                      </div>

                      <p className="text-muted" style={{ fontSize: "0.9rem", lineHeight: "1.6" }}>
                        Building trust and strong connections is key. A friendly, appreciation-first approach creates long-term supporters.
                      </p>
                    </div>

                    <div className="p-3 bg-gradient-success rounded-4 text-white text-center mt-3 shadow-sm" style={{ background: "linear-gradient(87deg, #2dce89 0, #2dcecc 100%)" }}>
                      <h5 className="text-white mb-0 font-weight-700">
                        <i className="fas fa-heart mr-2"></i> The friendlier you are, the more likely they are to buy eventually!
                      </h5>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              {/* Right Side: Interactions List */}
              <Col lg="6" className="mb-4">
                <Card className="border-0 shadow-sm rounded-4 h-100 bg-white">
                  <CardBody className="p-4">
                    <h4 className="text-success font-weight-700 mb-3 d-flex align-items-center">
                      <i className="fas fa-comments mr-2 text-success"></i> In Interactions with Fans...
                    </h4>
                    <p className="text-muted mb-4" style={{ fontSize: "0.9rem" }}>
                      Follow these best practices during direct messages, chats, or video sessions:
                    </p>

                    <ListGroup className="list-group-flush">
                      {[
                        { text: "Share your personal sports experiences and say thank you.", icon: "fa-share-alt", color: "#5e72e4", bg: "#f0f3ff" },
                        { text: "Ask them if you can teach them how to use the site.", icon: "fa-chalkboard-teacher", color: "#2dce89", bg: "#f0fdf4" },
                        { text: "Tell them how much you appreciate their support and help.", icon: "fa-thumbs-up", color: "#11cdef", bg: "#e6faff" },
                        { text: "Smile and always wish them a great day.", icon: "fa-smile-beam", color: "#ff2e93", bg: "#fff0f6" }
                      ].map((item, idx) => (
                        <ListGroupItem key={idx} className="border-0 px-0 py-3 d-flex align-items-start bg-transparent">
                          <span 
                            className="d-flex align-items-center justify-content-center rounded-circle mr-3 shadow-sm"
                            style={{
                              minWidth: "36px",
                              height: "36px",
                              backgroundColor: item.bg,
                              color: item.color
                            }}
                          >
                            <i className={`fas ${item.icon}`} style={{ fontSize: "14px" }}></i>
                          </span>
                          <span className="text-dark font-weight-600 pt-1" style={{ fontSize: "0.95rem", lineHeight: "1.4" }}>
                            {item.text}
                          </span>
                        </ListGroupItem>
                      ))}
                    </ListGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default HowYouSucceed;
